export class ChaseProfileTransactionDetails {
    OrderIds: string;
    TransId: string;
    InvoiceIds: string;
    TransAmount: string;
    AccountExecutive: string;
    Station: string;
    PaymentMode: string;
}



// WEBPACK FOOTER //
// ./src/app/external-user/Model/ChaseProfileTransactionDetails.ts